export class Transport {
    Code: string;
    Name: string;
  }